import { get } from 'lodash';
import { isEmpty } from '@/common/helpers';
import {
    defaultState as baseState,
    mutations as baseMutations,
    actions as baseActions
} from './searchBase';

export const defaultState = {
    entityName: 'auditlogs',
    baseUrl: 'api/auditLogs/',
    tableName: 'auditLogsTable',
    ...baseState,
    eventMethodOptions: []
};

export const mutations = {
    ...baseMutations,
    setEventMethodOptions(state, value) {
        state.eventMethodOptions = Array.isArray(value) ? value : [];
    }
};

export const actions = {
    ...baseActions,
    fetchAuditLogs(
        { commit, dispatch, state, rootGetters },
        { searchParams, filterParams }
    ) {
        const currentVenue = rootGetters['venue/currentVenue'];
        console.log('calling fetchAuditLogs', searchParams, filterParams);
        const notifyConfig = {
            notifyRequestPending: true
        };
        return dispatch('fetchItems', {
            searchParams,
            filterParams: {
                ...filterParams,
                venue: currentVenue
            },
            notifyConfig,
            saveParams: true,
            isDsSearch: false
        }).then(res => {
            const { content, ...page } = res.data;
            commit('setItems', content);
            commit('setResponseQuery', { ...page });
            commit('setRequestQuery', {
                ...state.requestQuery,
                size: page.size,
                number: page.number
            });
        });
    },
    async fetchAuditLogsOptions({ commit, state }) {
        console.log('calling fetchAuditLogsOptions');
        if (!isEmpty(state.optionsConfig)) {
            const eventMethods =
                get(state.optionsConfig, 'eventMethodOptions') || [];
            commit('setEventMethodOptions', eventMethods);
        }
    }
};

export default {
    namespaced: true,
    state: defaultState,
    mutations,
    actions
};
